import { Component, Input } from "@angular/core"

@Component({
  selector: "events-list",
  templateUrl: "index.html",
})
export class EventsList {

  @Input() events: any = []  
}



// WEBPACK FOOTER //
// ./src/components/events-list/index.ts